import { render, staticRenderFns } from "./TheCourseDetailsModal.vue?vue&type=template&id=5d9e1219&"
import script from "./TheCourseDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./TheCourseDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
